export const version = {
    versionString: "integration-main-0.0.254"
}